module.exports = __webpack_public_path__ + "img/bus-legend-1.64368077.svg";